/* DON'T EDIT THIS FILE: edit original and run build again */ export const intersperse = <TArrayElement>(
  array: TArrayElement[],
  separatorCallback: (index: number) => TArrayElement
): TArrayElement[] =>
  array.reduce<TArrayElement[]>(
    (prev, curr, i) =>
      i === 0 ? [curr] : [...prev, separatorCallback(i), curr],
    []
  );
